import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "questionMark" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M7.34253 7.20371C7.71853 6.13486 8.46067 5.23356 9.43752 4.65946C10.4144 4.08536 11.5629 3.8755 12.6796 4.06706C13.7964 4.25861 14.8093 4.83921 15.539 5.70603C16.2687 6.57284 16.668 7.66994 16.6664 8.803C16.6664 12.0016 11.8685 13.6008 11.8685 13.6008V15.661",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector_2",
    d: "M11.9966 19.998H12.0144",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }